import React, { FunctionComponent, Suspense } from "react";

const DotLottieReact = React.lazy(() =>
  import("@lottiefiles/dotlottie-react").then((m) => ({
    default: m.DotLottieReact,
  })),
);

export const CarLoadingAnimation: FunctionComponent = () => {
  return (
    <Suspense fallback={null}>
      <DotLottieReact src="/animations/car-loading.lottie" loop={true} autoplay />
    </Suspense>
  );
};
